module.exports = __webpack_public_path__ + "img/fb2264e.jpg";